/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react'
import {Button, Grid, Input, InputLabel, Modal} from '@scuf/common';
import {injectIntl} from "react-intl";
import Loader from "./Loader";

class SubmitPasswordModal extends React.Component {

    constructor(props) {
        super(props)
        this.state = {password: ''}

        this.onSubmit = this.onSubmit.bind(this)
        this.onClose = this.onClose.bind(this)
        this.renderConnectorMessage = this.renderConnectorMessage.bind(this)
    }

    onSubmit() {
        this.props.onSubmit(this.state)
        this.setState({...this.state, password: ''});
    }

    onClose() {
        this.setState({...this.state, password: ''});
        this.props.onClose();
    }

    render() {
        const {intl} = this.props

        return (
            <React.Fragment>
                <Modal closeIcon={true} onClose={this.props.onClose} open={this.props.open} closeOnDimmerClick={false}>
                    <Modal.Header>
                        {intl.formatMessage({id: 'admin.password.modal.header'})}
                    </Modal.Header>
                    <Modal.Content>

                        <Grid>
                            <Loader loading={this.props.loading}/>
                            <Grid.Row>
                                <Grid.Column width={12}>
                                    <p>{intl.formatMessage({id: 'admin.password.modal.description'})}</p>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column>
                                    <InputLabel label={intl.formatMessage({id: 'admin.password.modal.password'})} />
                                </Grid.Column>
                                <Grid.Column>
                                    <Input placeholder={intl.formatMessage({id: 'admin.password.modal.password.placeholder'})}
                                           type="password"
                                           onChange={value => this.setState({password:  value})}
                                           value={this.state.password}
                                           fluid
                                           onEnter={() => this.onSubmit()}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={12}>
                                    {this.renderConnectorMessage()}
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Modal.Content>
                    <Modal.Footer>
                        <div className="cancel-save-button-div">
                            <Button type="secondary" size="medium" content={intl.formatMessage({id: 'admin.password.modal.button.cancel'})} onClick={this.onClose} className="mobile-max-width-button"/>
                            <Button type="primary" size="medium" disabled={this.state.password === ''} content={intl.formatMessage({id: 'admin.password.modal.button.submit'})} onClick={this.onSubmit} className="mobile-max-width-button"/>
                        </div>
                    </Modal.Footer>
                </Modal>
            </React.Fragment>
        );
    }

    renderConnectorMessage() {
        const {connectorMessage, intl} = this.props

        if(!connectorMessage || !connectorMessage.errorKey) {
            return null;
        }

        let message = '';
        if(connectorMessage && connectorMessage.errorKey) {
            message = intl.formatMessage({id: connectorMessage.errorKey})
        }

        return(
            <React.Fragment>
                <h3>{intl.formatMessage({id: 'learningLoop.connector.explain.title'})}</h3>
                <div className="error-message">{message}</div>
            </React.Fragment>
        );

    }
}

export default injectIntl(SubmitPasswordModal)